import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_backer_center_header = _resolveComponent("backer-center-header")
  const _component_box = _resolveComponent("box")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createBlock(_component_skeleton_wrapper, null, {
    default: _withCtx(() => [
      _createVNode(_component_box, { class: "_flexcol _gap-3" }, {
        default: _withCtx(() => [
          _createVNode(_component_backer_center_header, null, {
            prefix: _withCtx(() => [
              _createVNode(_component_skeleton_image, { size: 42 })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_skeleton_line, {
                height: 18,
                "width-percent": 35
              })
            ]),
            suffix: _withCtx(() => [
              _createVNode(_component_skeleton_line, {
                height: 18,
                "width-percent": 18
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_skeleton_line, {
            height: 16,
            "width-percent": 28
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}